















import Vue from "vue";
import GeneralSettings from "../components/modules/settings/GeneralSettings.vue";
import SubscriptionsSettings from "../components/modules/settings/SubscriptionsSettings.vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import Utils from "@/utils";

export default Vue.extend({
    name: "Settings",
    components: { Toolbar, GeneralSettings },
    created() {
        document.title = Utils.getPageTitle(`${this.$t("general.toolbar.settings")}`, "before");
    }
});
